import React from 'react';
import { 
  Box, 
  Typography, 
  Table, 
  TableBody, 
  TableCell, 
  TableHead, 
  TableRow,
  Button
} from '@mui/material';

interface DisplayTransaction {
  id: string;
  date: string | Date;
  description: string;
  amount: number;
  type?: string;
  status?: string;
}

interface RecentTransactionsProps {
  transactions: DisplayTransaction[];
  onViewAll: () => void;
}

export const RecentTransactions: React.FC<RecentTransactionsProps> = ({
  transactions,
  onViewAll
}) => {
  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
        <Typography variant="h6">Recent Transactions</Typography>
        <Button onClick={onViewAll}>View All</Button>
      </Box>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Date</TableCell>
            <TableCell>Description</TableCell>
            <TableCell align="right">Amount</TableCell>
            <TableCell>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {transactions.map((transaction) => (
            <TableRow key={transaction.id}>
              <TableCell>
                {transaction.date instanceof Date 
                  ? transaction.date.toLocaleDateString() 
                  : new Date(transaction.date).toLocaleDateString()
                }
              </TableCell>
              <TableCell>{transaction.description}</TableCell>
              <TableCell align="right">
                ${Math.abs(transaction.amount).toFixed(2)}
              </TableCell>
              <TableCell>{transaction.status}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
}; 